/**
* 分页公共组件
* @author shaochj 2017-03-08
* @params pagination对象，
*  currentPage--当前页，totalSize--总页数，layout--样式，
*  currentChange--页切换事件
*/
<template>
    <el-row>
        <el-col :span="24" class="bottom-rom">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage"
                    :page-size="pagination.pageSize"
                    :page-sizes="pagination.pageSizes"
                    :layout="pagination.layout"
                    :total="pagination.totalSize">
            </el-pagination>
        </el-col>
    </el-row>
</template>

<script>
    export default {

        props:{
            pagination:Object
        },
        /*data:function() {
         return {

         }
         },
         mounted:function() {//初始加载
         var _self = this;
         }*/
        methods: {
            /*handleSizeChange(val) {

            },
            handleCurrentChange(val) {
                this.currentPage = val;
              
            }*/
            handleCurrentChange:function(val){
                this.$emit('currentChange',val);
            },
            handleSizeChange:function(val){
                this.$emit('sizeChange',val);
            }
        }
    }
</script>
<style>
    .bottom-rom{
        height: 50px;
    }
    .bottom-rom .el-pagination{
        padding-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pub/components/BottomPage.vue